import { CommunityRemovalStatus } from '../../../../common/enums/CommunityRemovalStatus';
import { StyledTable } from '../StatusTable.styled';
import { type Report, type ReportEntry } from '../../../../common/interfaces';

interface ReportProps {
  communityId: number;
  communityName: string;
  communityUrl: string;
  removeDate: string;
  mediaFilesStatus: string;
  userRemovalStatus: string;
  communityDataStatus: string;
  report: Report;
  isAdvanced?: boolean;
}

export const StatusReport = ({
  communityId,
  communityName,
  communityUrl,
  mediaFilesStatus,
  userRemovalStatus,
  communityDataStatus,
  removeDate,
  report,
  isAdvanced = false
}: ReportProps) => {
  const notAvaiableYet = 'Not available yet';

  const getRowCountOrFallback = (tableName: string): number => {
    const entries = report.init as ReportEntry[];
    const entry = entries.find((f) => f.table_name === tableName);
    return (entry?.row_count as number) ?? 0;
  };

  const dataTable = isAdvanced
    ? {
        caption: 'Advanced Report',
        head: [
          {
            cells: [
              { children: 'Table', isHeader: true, isSortable: false },
              { children: 'Row count', isHeader: true, isSortable: false },
              { children: 'Table', isHeader: true, isSortable: false },
              { children: 'Post process row count', isHeader: true, isSortable: false }
            ]
          }
        ],
        body: (report.init as ReportEntry[]).map((item, index: number) => ({
          cells: [
            { children: item.table_name },
            { children: item.row_count },
            { children: report.end[index].table_name },
            { children: report.end[index].row_count }
          ]
        }))
      }
    : {
        caption: 'Report',
        body: [
          {
            cells: [{ children: 'Community Id' }, { children: communityId }]
          },
          {
            cells: [{ children: 'Community Name' }, { children: communityName }]
          },
          {
            cells: [{ children: 'Community Url' }, { children: communityUrl }]
          },
          {
            cells: [{ children: 'Decommission Date' }, { children: removeDate }]
          },
          {
            cells: [
              { children: 'Number of Media Files' },
              {
                children:
                  mediaFilesStatus === CommunityRemovalStatus.Completed ? getRowCountOrFallback('file') : notAvaiableYet
              }
            ]
          },
          {
            cells: [
              { children: 'Number of Users' },
              {
                children:
                  userRemovalStatus === CommunityRemovalStatus.Completed
                    ? getRowCountOrFallback('user')
                    : notAvaiableYet
              }
            ]
          },
          {
            cells: [
              { children: 'Number of Ideas, Comments and Blogs' },
              {
                children:
                  communityDataStatus === CommunityRemovalStatus.Completed
                    ? getRowCountOrFallback('post')
                    : notAvaiableYet
              }
            ]
          }
        ]
      };

  return <StyledTable data={dataTable} data-testid="status-report-table" />;
};
